<div (click)="openPopup($event)" tappable>{{ value | CompanyLocalized : 'timeFormat' }}</div>
